export const LOCATION_ORIGIN = window.location.origin;
export const DOMAIN = `${LOCATION_ORIGIN}/predictorService`; // urlSource  === 1
export const SIGNAL_R_URL = `${DOMAIN}/hub`;
export const TRANSLATIONS_API = `${LOCATION_ORIGIN}/translationService/api/v1`;
export const API = `${LOCATION_ORIGIN}/predictorService/api`;
export const STATISTICS_API = `${LOCATION_ORIGIN}/statisticService`; //urlSource  === 2
export const SOCIAL_SHARE_URL = 'https://predictor-api-stage.rpd.cloud/socialMedia/shared';
